import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { components } from '../../../ui/styles/components';

export const AppTheme: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const themeOptions: ThemeOptions = createTheme({
    components,
    palette: {
      mode: 'light',
      primary: {
        main: '#3253e4',
        light: '#eff6ff',
        dark: '#002be8',
      },
      secondary: {
        main: '#f50057',
      },
      success: {
        main: '#219A4D',
        light: '#dbf6e5',
        dark: '#0d9840',
      },
      error: {
        main: '#bf2d2d',
        dark: '#990000',
      },
      info: {
        main: '#3253e4',
        dark: '#002be8',
      },
      warning: {
        main: '#EF9D07',
      },
      divider: 'rgba(0,0,0,0.12)',
      text: {
        primary: '#111827',
        secondary: '#232323',
        disabled: '#b5b5b5',
      },
    },
    typography: {
      fontFamily: 'Inter'
    }
  });

  return (
    <ThemeProvider theme={themeOptions}>{children}</ThemeProvider>
  );
};
